import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

window.Swiper = Swiper;

export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('carruselComponent', (slides) => {
        return {
          activeIndex: 0,
          slides,
          loading: true,
          next() {
            this.activeIndex = (this.activeIndex + 1) % this.slides.length;
          },
          prev() {
            this.activeIndex =
              (this.activeIndex - 1 + this.slides.length) % this.slides.length;
          },
          getIndex(addition) {
            const index = this.activeIndex + (addition || 0);
            if (index < 0) {
              return this.slides.length - 1;
            }
            if (index >= this.slides.length) {
              return 0;
            }
            return index;
          },
        };
      });
    });
  },
};
